import styled from 'styled-components'

export const Container = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-template-rows: 45px auto auto auto;
	place-items: center;
	margin: 30% 0;
	height: 100%;
	gap: 40px;
	position: relative;
	left: 0;
	animation: fadeSlide 0.4s;

	@keyframes fadeSlide {
		0% {
			left: -70px;
			opacity: 0;
		}
		100% {
			opacity: 1;
			left: 0;
		}
	}

	@media screen and (min-width: 390px) {
		margin: 35% 0;
	}

	@media screen and (min-width: 576px) {
		margin: 15% 0;
	}

	svg {
		margin-bottom: 20px;
	}
`

export const Title = styled.p`
	font-weight: 600;
	font-size: 18px;
	line-height: 26px;
	display: flex;
	align-items: center;
	text-align: center;
	color: #64778f;

	@media screen and (min-width: 390px) {
		font-size: 20px;
	}
`
export const Description = styled.div<{ variant?: boolean }>`
	font-style: normal;
	font-weight: ${({ variant }) => (variant ? 700 : 400)};
	font-size: 18px;
	line-height: 26px;
	text-align: center;
	color: ${({ variant }) => (variant ? '#5082c2' : '#64778F')};
	max-width: 220px;
	width: 100%;

	@media screen and (min-width: 390px) {
		max-width: 330px;
	}

	@media screen and (min-width: 576px) {
		max-width: 390px;
	}
`

export const BrandsContainer = styled.div`
	display: grid;
	grid-template-rows: 1fr;
	place-items: center;
	gap: 20px;
`

export const DescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`
